/*
 * Extracts an error message from a HTTP response object.
 */
(function() {
    'use strict';

    angular.module('paysera.toast').factory('errorExtractor', errorExtractorFactory);

    errorExtractorFactory.$inject = ['messageResolver'];

    function errorExtractorFactory(messageResolver) {
        return {
            extract: extract
        };

        function extract(response) {
            if (response.hasOwnProperty('data') && response['data'] !== undefined && response['data'] !== null) {
                var parsed = parseDataObject(response['data']);
                if (parsed !== 'unknown_error') {
                    return parsed;
                }
                if (response['data'].hasOwnProperty('data')) {
                    return parseDataObject(response['data']['data']);
                }
            }
            return 'unknown_error';

            function parseDataObject(data) {
                if(data.hasOwnProperty('error')) {
                    var context = '';
                    if (
                        response.hasOwnProperty('config')
                        && response['config'].hasOwnProperty('error_context')
                    ) {
                        context = response['config']['error_context'];
                    }
                    return messageResolver.resolve(data['error'], context);
                }
                return 'unknown_error';
            }
        }
    }
})();
